/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Gotopreviouspage3Inputs */

const he_common_gotopreviouspage3 = /** @type {(inputs: Common_Gotopreviouspage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עבור לעמוד הקודם`)
};

const en_common_gotopreviouspage3 = /** @type {(inputs: Common_Gotopreviouspage3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to previous page`)
};

/**
* | output |
* | --- |
* | "Go to previous page" |
*
* @param {Common_Gotopreviouspage3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_gotopreviouspage3 = /** @type {((inputs?: Common_Gotopreviouspage3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Gotopreviouspage3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_gotopreviouspage3(inputs)
	return en_common_gotopreviouspage3(inputs)
});
export { common_gotopreviouspage3 as "common_goToPreviousPage" }